type PendoOptions = {
    visitor: {
        id: string;
        email: string;
        full_name: string;
    };
    inlineStyleNonce: string;
};

declare global {
    interface Window {
        pendo:
            | {
                  visitorId: string | undefined;
                  identify: (options: PendoOptions) => unknown;
                  initialize: (options: PendoOptions) => unknown;
              }
            | undefined;
    }
}

export const initializePendo = (user: PendoOptions['visitor']) => {
    try {
        const { pendo } = window;

        if (!pendo) {
            throw new Error('window.pendo is not defined');
        }

        const inlineStyleNonce =
            document.querySelector('meta[name="inline-nonce"]')?.getAttribute('content') ??
            (() => {
                throw new Error('Failed to retrieve meta tag content');
            })();

        const options: PendoOptions = {
            visitor: user,
            inlineStyleNonce,
        };

        if (pendo.visitorId) {
            pendo.identify(options);
        } else {
            pendo.initialize(options);
        }
    } catch (error) {
        console.error('Failed to initialize Pendo:\n', error);
    }
};
